import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getTaskType = createAsyncThunk(
  '/getTaskType',
  async () => {
    const response = await axios.get('/GetTaskType');
    return response.data;
  }
);

export const getTaskTypeDetails = createAsyncThunk(
  '/getTaskTypeDetails',
  async (id) => {
    const response = await axios.get(`/GetTaskTypeDetails/${id}`);
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

const taskTypeSlice = createSlice({
  name: 'taskType',
  initialState: {
    loading: false,
    error: '',
    taskType: [],
    taskTypeDescriptions: [],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },

    resetDescriptions(state) {
      state.taskTypeDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    }
  },

  extraReducers: {
    [getTaskType.pending]: (state) => {
      state.loading = true;
    },
    [getTaskType.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTaskType.fulfilled]: (state, action) => {
      state.taskType = action.payload;
      state.loading = false;
    },
    [getTaskTypeDetails.pending]: (state) => {
      state.loading = true;
    },
    [getTaskTypeDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getTaskTypeDetails.fulfilled]: (state, action) => {
      state.taskTypeDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.taskTypeDescriptions = action.payload;
      state.loading = false;
    }
  }
});

export const taskTypeActions = taskTypeSlice.actions;

export default taskTypeSlice;
